import createStore from "@Stores/base-factories"
import hookSiteSelectedFactory from "@Stores/base-factories/store-site-selection"

const { Provider, useStore } = createStore()
  .extend(hookSiteSelectedFactory('siteId'))
  .extendHookPivotTableStoreFactory('impressions')
  .extendReportViewFactory('impression-pivot')
  .factory()

export {
  Provider as ImpressionPivotProvider,
  useStore as useImpressionPivotStore,
}
